import React from 'react';

import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

// What the number means, for superusers who did not set up the AI review.
const CONFIDENCE_HINT =
  "AI confidence: the model's own estimate, from 0 to 100%, that this verdict (approved or failed) is right. " +
  'It is not a measured probability and has not been checked against real outcomes, so read a low value as ' +
  '"worth a second look", not as a score.';

const PROVIDER_HINTS: Record<string, string> = {
  gemini: 'Gemini gives almost every field 90–100%, whatever the field, so for Gemini reviews it says little.',
};

export const confidenceHint = (provider?: string | null) =>
  [CONFIDENCE_HINT, PROVIDER_HINTS[provider || '']].filter(Boolean).join(' ');

interface IConfidenceChipProps {
  confidence: number;
  provider?: string | null;
  className?: string;
}

const ConfidenceChip = ({ confidence, provider, className }: IConfidenceChipProps) => (
  <Tooltip title={confidenceHint(provider)} arrow enterTouchDelay={0}>
    <Chip
      size="small"
      variant="outlined"
      className={className}
      label={`${confidence}%`}
      aria-label={`AI confidence ${confidence}%`}
      data-testid="ai-review-confidence"
    />
  </Tooltip>
);

export default ConfidenceChip;
